import Administration from "./Administration";

export default Administration;
